// Persistência do fluxo de cadastro MFA em sessionStorage, para um F5 não
// jogar a pessoa de volta ao início do login.
//
// Como funciona:
// - `saveMfaFlow` roda a cada mudança de step do cadastro (writer do
//   useMfaFlowPersistence) e grava { step, user, app, mandatory }.
// - No F5, `readMfaStep` reabre o login direto no step salvo e o
//   useMfaFlowPersistence reidrata user/app via `readMfaFlow`. O QR não é
//   salvo: o step mfaEnroll refaz o associate para regenerá-lo.
// - Nada sensível vai para o storage: secret, otpUri e mfaEnrollmentSession
//   ficam só em memória.
// - Fluxo obrigatório (mandatory: true) não é restaurável: sem a
//   mfaEnrollmentSession (credencial de posse, TTL de 5min no BE) não dá
//   para retomar o cadastro. O `readMfaFlow` descarta esse registro e a
//   pessoa refaz o login do zero.

const STORAGE_KEY = 'mfa-flow';

// Só a sub-jornada de cadastro é restaurável; o desafio (mfaChallenge) não.
export const RESTORABLE_MFA_STEPS = [
  'mfaEnrollInvite',
  'mfaInstall',
  'mfaEnroll',
  'mfaVerify',
];

// Leitura pura, sem efeito colateral — usada pelo saveMfaFlow no merge.
const parseStoredFlow = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!RESTORABLE_MFA_STEPS.includes(parsed?.step)) return null;
    return parsed;
  } catch (error) {
    return null;
  }
};

export const readMfaFlow = () => {
  const parsed = parseStoredFlow();
  if (!parsed) return null;
  // Fluxo obrigatório não é restaurável (ver doc do topo).
  if (parsed.mandatory) {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (removeError) {
      // ignora
    }
    return null;
  }
  return parsed;
};

export const saveMfaFlow = ({ step, user, app, mandatory }) => {
  if (!RESTORABLE_MFA_STEPS.includes(step)) return;
  try {
    // No F5 o writer roda antes do restore, com user/app nulos — preserva o
    // que já está salvo em vez de sobrescrever com null.
    const previous = parseStoredFlow();
    const nextUser = user || previous?.user || null;
    const nextApp = app || previous?.app || null;
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        step,
        user: nextUser,
        app: nextApp,
        mandatory: !!mandatory,
      }),
    );
  } catch (error) {
    // sessionStorage indisponível (ex.: modo restrito) — ignora.
  }
};

export const readMfaStep = steps => {
  const flow = readMfaFlow();
  return flow ? steps[flow.step] : null;
};

export const clearMfaFlow = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // ignora
  }
};
